<template>
  <Toast />
  <div class="card-header">
    <h4>Predios Proveedores</h4>
    <div class="line_title"></div>
  </div>
  <div class="card-body">
    <!-- DT Ppredios -->
    <DataTable
      ref="dt"
      :value="ppredios"
      :paginator="true"
      :rows="10"
      style="zoom: 0.8"
      :loading="loading"
      removableSort
      :globalFilterFields="[
        'id',
        'proveedor.rut_dv',
        'proveedor.razon_social',
        'origen._nombre',
        'nombre',
        'rol',
        'fsc_codes',
        'volumen_maximo',
        'volumen_pendiente',
        'vigente',
        'created_at',
      ]"
      sortMode="multiple"
      dataKey="id"
      filterDisplay="row"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      v-model:filters="filters"
      responsiveLayout="scroll"
      breakpoint="990px"
    >
      <template #header>
        <!-- DT Toolbar-->
        <Toolbar class="">
          <template #start>
            <div
              class="table-header flex flex-column md:flex-row md:justiify-content-between"
            >
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>

          <template #end>
            <Button
              label="Crear Predio"
              icon="pi pi-plus"
              class="p-button-success"
              @click="openNew"
            />&nbsp;
            <Button
              label="Registrar Visita"
              icon="pi pi-book"
              class="p-button-info"
              @click="openNewVisita"
            />
            <download-excel
              class="btn btn-warning ms-1"
              style="border-radius: 0px; height: 40px"
              :data="pprediosExport"
              type="xlsx"
              name="ppredios.xlsx"
            >
              <i class="pi pi-file-excel mr-2"></i>
              Exportar a Excel
            </download-excel>
          </template>
        </Toolbar>
      </template>

      <Column field="id" header="Cod." sortable :hidden="true">
        <template #body="slotProps">
          <span>
            {{ slotProps.data.id }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column
        field="created_at"
        header="Fecha Creación"
        sortable
        dataType="date"
      >
        <template #body="slotProps">
          {{ formatFecha(slotProps.data.created_at, false) }}
        </template>

        <template #filter="{ filterModel, filterCallback }">
          <Calendar
            v-model="filterModel.value"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            placeholder=""
            @update:modelValue="filterCallback()"
            showIcon
          />
        </template>
      </Column>

      <Column field="proveedor.rut_dv" header="RUT" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.proveedor.rut_dv }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column field="proveedor.razon_social" header="Proveedor" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.proveedor.razon_social }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column
        field="origen._nombre"
        header="Origen"
        style="white-space: nowrap"
        sortable
      >
        <template #body="slotProps">
          <span>
            {{ slotProps.data.origen._nombre }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column field="nombre" header="Predio" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.nombre }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column field="rol" header="Rol" sortable>
        <template #body="slotProps">
          <span>
            {{ slotProps.data.rol }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column field="fsc" header="FSC">
        <template #body="slotProps">
          <span :title="slotProps.data.fscs[0]?.pivot.codigo">
            {{ slotProps.data.fscs[0]?.nombre }}
          </span>
        </template>

        <template #filter="{ filterModel, filterCallback }">
          <div v-if="filterModel">
            <InputText
              v-model="filterModel.value"
              @input="filterCallback"
              class="p-column-filter"
              placeholder=""
            />
          </div>
          <div v-else>
            <InputText
              v-model="filters.fsc_codes.value"
              @input="filterCallback"
              class="p-column-filter"
              placeholder=""
            />
          </div>
        </template>
      </Column>

      <Column
        field="volumen_maximo"
        header="Vol.Máx (M3)"
        style="text-align: right"
        sortable
      >
        <template #body="slotProps">
          <span>
            {{ formatCurrency(slotProps.data.volumen_maximo, false) }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column
        field="volumen_pendiente"
        header="Vol.Pendiente (M3)"
        style="text-align: right"
        sortable
      >
        <template #body="slotProps">
          <span
            :style="
              slotProps.data.volumen_pendiente > 0
                ? 'color: black'
                : 'color:red'
            "
          >
            {{ formatCurrency(slotProps.data.volumen_pendiente, false) }}
          </span>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column field="vigente" header="Estado" sortable>
        <template #body="slotProps">
          <Tag
            :value="slotProps.data.vigente ? 'ACTIVO' : 'INACTIVO'"
            :severity="slotProps.data.vigente ? 'success' : 'danger'"
          />
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            v-model="filterModel.value"
            type="text"
            @input="filterCallback()"
            class="p-column-filter"
            placeholder=""
          />
        </template>
      </Column>

      <Column header="Acciones" :exportable="false" style="white-space: nowrap">
        <template #body="slotProps">
          <Button
            icon="pi pi-book"
            class="p-button-rounded p-button-info"
            title="Visitas"
            @click="visitasPpredio(slotProps.data)"
          />&nbsp;
          <Button
            icon="pi pi-history"
            class="p-button-rounded p-button-success"
            title="Cambios"
            @click="bitacoraPpredio(slotProps.data)"
          />&nbsp;
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-warning"
            title="Editar"
            @click="editPpredio(slotProps.data)"
          />&nbsp;
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger"
            title="Eliminar"
            @click="confirmDeletePpredio(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <!-- Formulario Ppredios en modal -->
    <Dialog
      v-model:visible="ppredioDialog"
      :style="{ width: '100%' }"
      header="Predios Proveedores"
      :modal="true"
      class="p-fluid"
      :maximizable="true"
    >
      <form class="p-fluid">
        <div class="row col-md-12 field">
          <div class="col-md-3 field">
            <label for="proveedor" class="mt-3">Proveedor</label>
            <AutoComplete
              id="proveedor"
              v-model="v$.proveedor.$model"
              :class="{ 'p-invalid': v$.proveedor.$invalid && submitted }"
              :suggestions="filteredProveedores"
              @complete="searchProveedor($event)"
              @change="onProveedorSelect"
              field="_razon_social"
              :dropdown="true"
              forceSelection
              aria-describedby="proveedor-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="v$.proveedor.$error && submitted">
              <span
                id="proveedor-error"
                v-for="(error, index) of v$.proveedor.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (v$.proveedor.$invalid && submitted) ||
                v$.proveedor.$pending.$response
              "
              class="p-error"
            >
              {{
                v$.proveedor.required.$message.replace("Value", "Proveedor")
              }}</small
            >
          </div>

          <div class="col-md-3 field">
            <label for="origen" class="mt-3">Origen</label>
            <AutoComplete
              id="origen"
              v-model="v$.origen.$model"
              :class="{ 'p-invalid': v$.origen.$invalid && submitted }"
              :suggestions="filteredOrigenes"
              @complete="searchComuna($event)"
              field="_nombre"
              :dropdown="true"
              forceSelection
              aria-describedby="origen-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="v$.origen.$error && submitted">
              <span
                id="origen-error"
                v-for="(error, index) of v$.origen.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (v$.origen.$invalid && submitted) ||
                v$.origen.$pending.$response
              "
              class="p-error"
            >
              {{
                v$.origen.required.$message.replace("Value", "Origen")
              }}</small
            >
          </div>

          <div class="col-md-3 field">
            <label for="nombre" class="mt-3">Nombre</label>
            <InputText
              id="nombre"
              v-model="v$.nombre.$model"
              :class="{ 'p-invalid': v$.nombre.$invalid && submitted }"
              aria-describedby="nombre-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="v$.nombre.$error && submitted">
              <span
                id="nombre-error"
                v-for="(error, index) of v$.nombre.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (v$.nombre.$invalid && submitted) ||
                v$.nombre.$pending.$response
              "
              class="p-error"
            >
              {{
                v$.nombre.required.$message.replace("Value", "Nombre")
              }}</small
            >
          </div>

          <div class="col-md-3 field">
            <label for="rol" class="mt-3">Rol</label>
            <InputText
              id="rol"
              v-model="v$.rol.$model"
              :class="{ 'p-invalid': v$.rol.$invalid && submitted }"
              aria-describedby="rol-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="v$.rol.$error && submitted">
              <span
                id="rol-error"
                v-for="(error, index) of v$.rol.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (v$.rol.$invalid && submitted) || v$.rol.$pending.$response
              "
              class="p-error"
            >
              {{ v$.rol.required.$message.replace("Value", "Rol") }}</small
            >
          </div>

          <!-- Gestion FSC de predios-->
          <div class="row">
            <div class="col-md-6 field">
              <label for="fsc" class="mt-3">FSC</label>
              <Dropdown
                id="fsc"
                v-model="fscSeleccionado"
                :options="predioFscs"
                optionLabel="nombre"
                placeholder="Seleccione FSC"
                @change="onFscChange"
              />
            </div>
            <div class="col-md-6 field">
              <label for="fsc_codigo" class="mt-3">Código FSC</label>
              <!-- Leemos el código directamente del primer elemento del array -->
              <InputText
                id="fsc_codigo"
                :value="form.fscs[0]?.codigo || ''"
                readonly
                class="w-full"
              />
            </div>
          </div>

          <div class="col-md-4 field">
            <label for="volumen_maximo" class="mt-3">Vol.Máximo (M3)</label>
            <InputNumber
              id="volumen_maximo"
              v-model="v$.volumen_maximo.$model"
              style="text-align: right"
              :class="{ 'p-invalid': v$.volumen_maximo.$invalid && submitted }"
              @blur="setVolumenes()"
              aria-describedby="volumen_maximo-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="v$.volumen_maximo.$error && submitted">
              <span
                id="volumen_maximo-error"
                v-for="(error, index) of v$.volumen_maximo.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (v$.volumen_maximo.$invalid && submitted) ||
                v$.volumen_maximo.$pending.$response
              "
              class="p-error"
            >
              {{
                v$.volumen_maximo.required.$message.replace(
                  "Value",
                  "volumen_maximo"
                )
              }}</small
            >
          </div>

          <div class="col-md-4 field">
            <label for="volumen_recibido" class="mt-3">Recibido(M3)</label>
            <InputNumber
              id="volumen_recibido"
              v-model.trim="form.volumen_recibido"
              style="background: #d5d5d5"
              readonly="true"
              disabled="true"
            />
          </div>

          <div class="col-md-4 field">
            <label for="volumen_pendiente" class="mt-3">Pendiente(M3)</label>
            <InputNumber
              id="volumen_pendiente"
              v-model.trim="form.volumen_pendiente"
              disabled="true"
              style="background: #d5d5d5"
              readonly="true"
            />
          </div>

          <div class="col-md-8 field">
            <label for="observacion" class="mt-3">Observaciones</label>
            <InputText id="observacion" v-model.trim="form.observacion" />
          </div>

          <div class="col-md-4 field">
            <label for="vigente" class="mt-3">Estado</label><br />
            <ToggleButton
              id="vigente"
              v-model="v$.vigente.$model"
              :class="{ 'p-invalid': v$.vigente.$invalid && submitted }"
              onLabel="ACTIVO"
              offLabel="INACTIVO"
              onIcon="pi pi-check"
              offIcon="pi pi-times"
              aria-describedby="vigente-error"
              autofocus
              style="width: 100%"
            />
            <span v-if="v$.vigente.$error && submitted">
              <span
                id="vigente-error"
                v-for="(error, index) of v$.vigente.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (v$.vigente.$invalid && submitted) ||
                v$.vigente.$pending.$response
              "
              class="p-error"
            >
              {{
                v$.vigente.required.$message.replace("Value", "Estado")
              }}</small
            >
          </div>
        </div>
      </form>

      <template #footer>
        <div class="row">
          <div class="col-md-7 fw-lighter text-muted" style="text-align: left">
            <small v-if="form.created_id"
              ><i class="pi pi-user-plus" style="font-size: 1rem"></i>:
              {{ form.created_id.name }} el {{ form.created_at }}</small
            ><br />
            <small v-if="form.updated_id"
              ><i class="pi pi-user-edit" style="font-size: 1rem"></i>:
              {{ form.updated_id.name }} el {{ form.updated_at }}</small
            >
          </div>
          <div
            :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'"
            v-if="!saving"
          >
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text text-danger"
              @click="hideDialog"
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              class="p-button-text"
              @click="savePpredio"
            />
          </div>
          <div
            :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'"
            v-else
          >
            <ProgressBar mode="indeterminate" />
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Formulario PprediosVisitas en modal -->
    <Dialog
      v-model:visible="ppredioVisitaDialog"
      :style="{ width: '100%' }"
      header="Visita a Predios Proveedores"
      :modal="true"
      class="p-fluid"
      :maximizable="true"
    >
      <form class="p-fluid">
        <div class="row col-md-12 field">
          <div class="col-md-4 field">
            <label for="proveedor" class="mt-3">Proveedor Visitado</label>
            <AutoComplete
              id="proveedor"
              v-model="vVisita$.proveedor.$model"
              :class="{ 'p-invalid': vVisita$.proveedor.$invalid && submitted }"
              :suggestions="filteredProveedores"
              @complete="searchProveedor($event)"
              @update:modelValue="setPredios"
              field="_razon_social"
              :dropdown="true"
              forceSelection
              aria-describedby="proveedor-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="vVisita$.proveedor.$error && submitted">
              <span
                id="proveedor-error"
                v-for="(error, index) of vVisita$.proveedor.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (vVisita$.proveedor.$invalid && submitted) ||
                vVisita$.proveedor.$pending.$response
              "
              class="p-error"
            >
              {{
                vVisita$.proveedor.required.$message.replace(
                  "Value",
                  "Proveedor"
                )
              }}</small
            >
          </div>

          <div class="col-md-4 field">
            <label for="predio" class="mt-3">Predio</label>
            <AutoComplete
              id="ppredio"
              v-model="vVisita$.ppredio.$model"
              :class="{ 'p-invalid': vVisita$.ppredio.$invalid && submitted }"
              :suggestions="filteredPredios"
              @complete="searchPredio"
              field="_nombre"
              :dropdown="true"
              forceSelection
              aria-describedby="ppredio-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="vVisita$.ppredio.$error && submitted">
              <span
                id="ppredio-error"
                v-for="(error, index) of vVisita$.ppredio.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (vVisita$.ppredio.$invalid && submitted) ||
                vVisita$.ppredio.$pending.$response
              "
              class="p-error"
            >
              {{
                vVisita$.ppredio.required.$message.replace("Value", "Predios")
              }}
            </small>
          </div>
          <div class="col-md-4 field">
            <label for="fecha" class="mt-3">Fecha</label>
            <Calendar
              id="fecha"
              v-model="vVisita$.fecha.$model"
              :class="{ 'p-invalid': vVisita$.fecha.$invalid && submitted }"
              aria-describedby="fecha_doc_recep-error"
              autocomplete="off"
              :showIcon="true"
              dateFormat="dd/mm/yy"
            />
            <span v-if="vVisita$.fecha.$error && submitted">
              <span
                id="fecha-error"
                v-for="(error, index) of vVisita$.fecha.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (vVisita$.fecha.$invalid && submitted) ||
                vVisita$.fecha.$pending.$response
              "
              class="p-error"
            >
              {{
                vVisita$.fecha.required.$message.replace("Value", "Fecha")
              }}</small
            >
          </div>

          <div class="col-md-12 field">
            <label for="comentarios" class="mt-3">Comentarios</label>
            <InputText
              id="comentarios"
              v-model="vVisita$.comentarios.$model"
              :class="{
                'p-invalid': vVisita$.comentarios.$invalid && submitted,
              }"
              aria-describedby="comentarios-error"
              autofocus
              autocomplete="off"
            />
            <span v-if="vVisita$.comentarios.$error && submitted">
              <span
                id="comentarios-error"
                v-for="(error, index) of vVisita$.comentarios.$errors"
                :key="index"
              >
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small
              v-else-if="
                (vVisita$.comentarios.$invalid && submitted) ||
                vVisita$.comentarios.$pending.$response
              "
              class="p-error"
            >
              {{
                vVisita$.comentarios.required.$message.replace(
                  "Value",
                  "comentarios"
                )
              }}</small
            >
          </div>
        </div>
      </form>

      <template #footer>
        <div class="row">
          <div class="col-md-7 fw-lighter text-muted" style="text-align: left">
            <small v-if="form.created_id"
              ><i class="pi pi-user-plus" style="font-size: 1rem"></i>:
              {{ form.created_id.name }} el {{ form.created_at }}</small
            ><br />
            <small v-if="form.updated_id"
              ><i class="pi pi-user-edit" style="font-size: 1rem"></i>:
              {{ form.updated_id.name }} el {{ form.updated_at }}</small
            >
          </div>
          <div
            :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'"
            v-if="!saving"
          >
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text text-danger"
              @click="hideDialogVisita"
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveVisita"
            />
          </div>
          <div
            :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'"
            v-else
          >
            <ProgressBar mode="indeterminate" />
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Confirmar elimina un ppredio -->
    <Dialog
      v-model:visible="deletePpredioDialog"
      :style="{ width: '470px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="confirmation-content">
        <i
          class="pi pi-exclamation-triangle mr-3 text-warning"
          style="font-size: 2rem; vertical-align: middle"
        />
        <span v-if="ppredio"> ¿Está seguro de borrar el predio?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="deletePpredioDialog = false"
        />
        <Button
          label="Si"
          icon="pi pi-check"
          class="p-button-text text-danger"
          @click="deletePpredio"
        />
      </template>
    </Dialog>

    <!-- Confirmar elimina una visita a  ppredio -->
    <Dialog
      v-model:visible="deleteVisitaDialog"
      :style="{ width: '470px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="confirmation-content">
        <i
          class="pi pi-exclamation-triangle mr-3 text-warning"
          style="font-size: 2rem; vertical-align: middle"
        />
        <span v-if="ppredio"> ¿Está seguro de borrar la visita al predio?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteVisitaDialog = false"
        />
        <Button
          label="Si"
          icon="pi pi-check"
          class="p-button-text text-danger"
          @click="deleteVisita"
        />
      </template>
    </Dialog>

    <!-- Historial de cambios -->
    <Dialog
      v-model:visible="bitacoraPprediosDialog"
      :style="{ width: '470px' }"
      header="Historial de cambios"
      :modal="true"
    >
      <DataTable :value="bitacora" tableStyle="min-width: 50rem">
        <Column field="created_at" header="Fecha">
          <template #body="slotProps">
            <span>
              {{ formatFecha(slotProps.data.created_at) }}
            </span>
          </template>
        </Column>
        <Column field="created_user" header="Usuario">
          <template #body="slotProps">
            <span>{{
              slotProps.data.created_user.rut_dv +
              " " +
              slotProps.data.created_user.name
            }}</span>
          </template>
        </Column>
        <Column
          field="volumen_maximo"
          header="Vol.Máximo"
          bodyStyle="text-align:right"
        >
          <template #body="slotProps">
            <span>
              {{ formatCurrency(slotProps.data.volumen_maximo, false) }}
            </span>
          </template>
        </Column>
        <Column field="observacion" header="Observacion"></Column>
      </DataTable>
      <template #footer>
        <Button
          label="Cerrar"
          icon="pi pi-times"
          class="p-button-text"
          @click="bitacoraPprediosDialog = false"
        />
      </template>
    </Dialog>

    <!-- Visitas a Predios -->
    <Dialog
      v-model:visible="visitasPprediosDialog"
      :style="{ width: '470px' }"
      header="Visitas al Predio"
      :modal="true"
    >
      <DataTable :value="visitas" tableStyle="min-width: 50rem">
        <Column field="created_at" header="Fecha">
          <template #body="slotProps">
            <span>
              {{ formatFecha(slotProps.data.fecha) }}
            </span>
          </template>
        </Column>
        <Column field="created_user" header="Usuario">
          <template #body="slotProps">
            <span>{{
              slotProps.data.created_user.rut_dv +
              " " +
              slotProps.data.created_user.name
            }}</span>
          </template>
        </Column>
        <Column field="comentarios" header="Comentarios"></Column>
        <Column header="Acciones">
          <template #body="slotProps">
            <Button
              icon="pi pi-trash"
              class="p-button-danger p-button-sm"
              @click="confirmDeletePpredioVisita(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
      <template #footer>
        <Button
          label="Cerrar"
          icon="pi pi-times"
          class="p-button-text"
          @click="visitasPprediosDialog = false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import usePpredios from "../../composables/cruds/ppredios";
import { ref, reactive, onMounted, computed } from "vue";
import moment from "moment";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

export default {
  setup() {
    const {
      ppredio,
      ppredios,
      proveedores,
      origenes,
      dt,
      loading,
      saving,
      filters,
      bitacora,
      bitacoraPprediosDialog,
      ppredio_visita,
      visitas,
      visitasPprediosDialog,
      deletePpredioDialog,
      ppredioDialog,
      ppredioVisitaDialog,
      submitted,
      filteredProveedores,
      filteredPredios,
      filteredOrigenes,
      messages,
      storePpredio,
      storeVisita,
      getCRUD,
      deletePpredio,
      deleteVisitaDialog,
      deleteVisita,
    } = usePpredios();

    moment.locale("es");

    const predioFscs = ref([]); // Las opciones que vienen del proveedor
    const fscSeleccionado = ref(null); // El objeto que tiene el Dropdown actualmente
    const fsc_codigo_temporal = ref(""); // Para mostrar el código en el input readonly

    const form = reactive({
      proveedor: "",
      origen: "",
      nombre: "",
      rol: "",
      fscs: [],
      fsc_codigo: "", // Para el input readonly
      volumen_maximo: 0,
      volumen_recibido: 0,
      volumen_pendiente: 0,
      observacion: "",
      vigente: 1,
    });

    const formVisita = reactive({
      proveedor: "",
      ppredio: "",
      comentarios: "",
      fecha: "",
    });

    const openNew = () => {
      ppredio.value = {};
      submitted.value = false;
      ppredioDialog.value = true;
      saving.value = false;

      // reset form y auxiliares
      form.proveedor = null;
      form.origen = null;
      form.nombre = "";
      form.rol = "";
      form.volumen_maximo = 0;
      form.volumen_recibido = 0;
      form.volumen_pendiente = 0;
      form.vol_m3 = 0;
      form.vol_mr = 0;
      form.observacion = null;
      form.vigente = true;
      form.fscs = [];
      form.fsc_codigo = ""; // Para el input readonly
    };

    const openNewVisita = () => {
      ppredio_visita.value = {};
      submitted.value = false;
      ppredioVisitaDialog.value = true;
      saving.value = false;

      formVisita.fecha = "";
      formVisita.comentarios = "";
    };
    const editPpredio = (pred) => {
      // 1. Cargar el diálogo y clonar datos básicos
      ppredio.value = { ...pred };
      ppredioDialog.value = true;

      // 2. BUSCAR EL PROVEEDOR COMPLETO (El que tiene los FSCs)
      // Asumo que 'data.proveedores' es tu array maestro donde el ID 2161 SI tiene fscs
      const proveedorCompleto = proveedores.value.find(
        (p) => p.id === pred.proveedor.id
      );

      if (proveedorCompleto) {
        // Llenamos las opciones del Dropdown con la data maestra
        predioFscs.value = proveedorCompleto.fscs;

        // Actualizamos el proveedor del form para que sea el "completo"
        form.proveedor = proveedorCompleto;
      } else {
        predioFscs.value = [];
        form.proveedor = pred.proveedor;
      }

      // 3. ASIGNAR EL FSC SELECCIONADO ACTUALMENTE
      // Buscamos en los fscs del predio (el que viene en pred.fscs)
      if (pred.fscs && pred.fscs.length > 0) {
        const fscDelPredio = pred.fscs[0]; // El objeto guardado en el predio

        // IMPORTANTE: Buscamos la referencia exacta en la lista predioFscs
        const match = predioFscs.value.find((f) => f.id === fscDelPredio.id);

        if (match) {
          fscSeleccionado.value = match; // Para el Dropdown
          form.fscs = [match]; // Para el objeto final
          form.fsc_codigo = match.codigo; // Para el InputText
        }
      } else {
        // Si no tiene nada seleccionado previamente
        fscSeleccionado.value = null;
        form.fscs = [];
        form.fsc_codigo = "";
      }

      // 4. Asignar el resto de los campos (origen, nombre, etc.)
      form.origen = pred.origen;
      form.nombre = pred.nombre;
      form.rol = pred.rol;
      form.volumen_maximo = parseFloat(pred.volumen_maximo || 0);
      form.volumen_recibido = parseFloat(pred.volumen_recibido || 0);
      form.volumen_pendiente = parseFloat(pred.volumen_pendiente || 0);
      form.observacion = pred.observacion;
      form.vigente = pred.vigente;
    };

    const rules = {
      proveedor: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      origen: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      nombre: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      rol: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      volumen_maximo: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      vigente: {
        required: helpers.withMessage("El campo es requerido", required),
      },
    };

    const rulesVisita = {
      proveedor: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      fecha: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      ppredio: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
      comentarios: {
        required: helpers.withMessage("El campo es requerido!", required),
      },
    };

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    const confirmDeleteSelected = () => {
      bitacoraPprediosDialog.value = true;
    };

    const confirmDeletePpredio = (emp) => {
      ppredio.value = emp;
      deletePpredioDialog.value = true;
    };

    const confirmDeletePpredioVisita = (visita) => {
      if (!visita || !visita.id) {
        console.error("Visita inválida:", visita);
        return;
      }

      // abrir diálogo de confirmación
      deleteVisitaDialog.value = true;
      ppredio_visita.value = visita; // guarda la visita seleccionada
    };

    const hideDialog = () => {
      ppredioDialog.value = false;
      submitted.value = false;
      saving.value = false;
    };

    const hideDialogVisita = () => {
      ppredioVisitaDialog.value = false;
      submitted.value = false;
      saving.value = false;
    };

    const searchProveedor = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredProveedores.value = [...proveedores.value];
        } else {
          filteredProveedores.value = proveedores.value.filter((proveedor) => {
            return proveedor._razon_social
              .toLowerCase()
              .includes(event.query.toLowerCase());
          });
        }
      }, 250);
    };

    const searchComuna = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredOrigenes.value = [...origenes.value];
        } else {
          filteredOrigenes.value = origenes.value.filter((origen) => {
            return origen._nombre
              .toLowerCase()
              .includes(event.query.toLowerCase());
          });
        }
      }, 250);
    };

    const searchPredio = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredPredios.value = [...ppredios.value];
        } else {
          filteredPredios.value = ppredios.value.filter((predio) => {
            return predio._nombre
              .toLowerCase()
              .includes(event.query.toLowerCase());
          });
        }
      }, 250);
    };

    const formatCurrency = (value, style = true) => {
      return style
        ? new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
          }).format(Number(value))
        : new Intl.NumberFormat("es-CL").format(Number(value.toFixed(0)));
    };

    const formatFecha = (value, conHora = true) => {
      if (!value) return "";
      return conHora
        ? moment(value).format("DD-MM-YYYY HH:mm") // con hora
        : moment(value).format("DD-MM-YYYY"); // solo fecha
    };

    const toggleDelete = (index) => {
      lineas.value.splice(index, 1);
      messages.value = [];
    };

    const setPredios = (nuevoProveedor) => {
      ppredios.value = nuevoProveedor?.predios || [];
      filteredPredios.value = [...ppredios.value]; // inicializar con todos
      formVisita.ppredio = null; // resetear selección
    };

    const saveVisita = () => {
      submitted.value = true;
      if (!vVisita$._value.$invalid) {
        messages.value = [];
        storeVisita(formVisita);
      }
    };

    const savePpredio = () => {
      // let i = 0;
      // let selection = JSON.parse(JSON.stringify(selectedFscs.value));
      // let codSelection = JSON.parse(JSON.stringify(selectedCodigoFscs.value));

      // $.each(selection, function (key, sel) {
      //   if (sel !== null) {
      //     sel[0].codigo =
      //       codSelection[i] === undefined ? null : codSelection[i];
      //   }
      //   i++;
      // });

      submitted.value = true;

      if (!v$._value.$invalid) {
        messages.value = [];
        storePpredio(form);
        // console.info('form 1: ', form)
      }
    };

    const setVolumenes = (event) => {
      form.volumen_pendiente =
        parseFloat(form.volumen_maximo) - parseFloat(form.volumen_recibido);
    };

    const bitacoraPpredio = (pred) => {
      bitacora.value = { ...pred.bitacora.reverse() };
      // console.info(bitacora.value);
      bitacoraPprediosDialog.value = true;
    };

    const visitasPpredio = (pred) => {
      visitas.value = pred.visitas.slice().reverse(); // copia y revierte
      visitasPprediosDialog.value = true;
    };

    const pprediosExport = computed(() => {
      const rows = [];
      let source = ppredios.value ?? [];

      // Filtro global (incluye fsc_codes)
      if (filters.value.global?.value) {
        const term = filters.value.global.value.toLowerCase();
        source = source.filter(
          (p) =>
            p.id?.toString().includes(term) ||
            p.proveedor?.rut_dv?.toLowerCase().includes(term) ||
            p.proveedor?.razon_social?.toLowerCase().includes(term) ||
            p.origen?._nombre?.toLowerCase().includes(term) ||
            p.nombre?.toLowerCase().includes(term) ||
            p.rol?.toLowerCase().includes(term) ||
            p.volumen_maximo?.toString().includes(term) ||
            p.volumen_pendiente?.toString().includes(term) ||
            (p.vigente ? "activo" : "inactivo").includes(term) ||
            p.created_at?.toString().includes(term) ||
            (p.fsc_codes || "").toLowerCase().includes(term)
        );
      }

      // Filtros por columna (igual que antes)
      if (filters.value["proveedor.id"]?.value) {
        source = source.filter(
          (p) => p.proveedor?.id == filters.value["proveedor.id"].value
        );
      }
      if (filters.value["proveedor.rut_dv"]?.value) {
        source = source.filter(
          (p) => p.proveedor?.rut_dv == filters.value["proveedor.rut_dv"].value
        );
      }
      if (filters.value["proveedor.razon_social"]?.value) {
        const term =
          filters.value["proveedor.razon_social"].value.toLowerCase();
        source = source.filter((p) =>
          p.proveedor?.razon_social?.toLowerCase().includes(term)
        );
      }
      if (filters.value["origen._nombre"]?.value) {
        const term = filters.value["origen._nombre"].value.toLowerCase();
        source = source.filter((p) =>
          p.origen?._nombre?.toLowerCase().includes(term)
        );
      }
      if (filters.value["nombre"]?.value) {
        const term = filters.value["nombre"].value.toLowerCase();
        source = source.filter((p) => p.nombre?.toLowerCase().includes(term));
      }
      if (filters.value["rol"]?.value) {
        const term = filters.value["rol"].value.toLowerCase();
        source = source.filter((p) => p.rol?.toLowerCase().includes(term));
      }
      if (filters.value["volumen_maximo"]?.value) {
        source = source.filter(
          (p) => p.volumen_maximo == filters.value["volumen_maximo"].value
        );
      }
      if (filters.value["volumen_pendiente"]?.value) {
        source = source.filter(
          (p) => p.volumen_pendiente == filters.value["volumen_pendiente"].value
        );
      }
      if (filters.value["vigente"]?.value !== null) {
        source = source.filter(
          (p) => p.vigente == filters.value["vigente"].value
        );
      }
      if (filters.value["created_at"]?.value?.length === 2) {
        const [desde, hasta] = filters.value["created_at"].value;
        source = source.filter((p) => {
          const fecha = new Date(p.created_at);
          return fecha >= desde && fecha <= hasta;
        });
      }

      // Construcción de filas para exportar
      source.forEach((p) => {
        // <-- declarar fscText aquí, dentro del scope del forEach
        rows.push({
          RUT: p.proveedor?.rut_dv,
          PROVEEDOR: p.proveedor?.razon_social,
          ORIGEN: p.origen?._nombre,
          PREDIO: p.nombre,
          ROL: p.rol,
          FSC: p.fscs[0]?.nombre,
          "VOLÚMEN MÁXIMO (M3)": formatCurrency(p.volumen_maximo, false),
          "VOLÚMEN PENDIENTE(M3)": formatCurrency(p.volumen_pendiente, false),
          ESTADO: p.vigente ? "ACTIVO" : "INACTIVO",
          "TIPO REGISTRO": "",
          FECHA: "",
          COMENTARIOS: "",
          USUARIO: "",
        });

        p.visitas.forEach((v) => {
          rows.push({
            RUT: "",
            PROVEEDOR: "",
            ORIGEN: "",
            PREDIO: "",
            ROL: "",
            FSC: "",
            "VOLÚMEN MÁXIMO (M3)": "",
            "VOLÚMEN PENDIENTE(M3)": "",
            ESTADO: "",
            "TIPO REGISTRO": "VISITA",
            FECHA: moment(v.created_at).format("DD-MM-YYYY"),
            COMENTARIOS: v.comentarios || "",
            USUARIO: `${v.created_user?.name || ""}`,
          });
        });

        p.bitacora.forEach((b) => {
          rows.push({
            RUT: "",
            PROVEEDOR: "",
            ORIGEN: "",
            PREDIO: "",
            ROL: "",
            FSC: "",
            "VOLÚMEN MÁXIMO (M3)": "",
            "VOLÚMEN PENDIENTE(M3)": "",
            ESTADO: "",
            "TIPO REGISTRO": "BITÁCORA",
            FECHA: moment(b.created_at).format("DD-MM-YYYY"),
            COMENTARIOS: b.observacion || `Set Vol.Máx en: ${b.volumen_maximo}`,
            USUARIO: `${b.created_user?.name || ""}`,
          });
        });
      });

      return rows;
    });

    const onFscChange = (event) => {
      if (event.value) {
        // Guardamos el objeto como el único elemento del array
        form.fscs = [event.value];
        // También actualizamos fsc_codigo si tu backend lo pide aparte
        form.fsc_codigo = event.value.codigo;
      } else {
        form.fscs = [];
        form.fsc_codigo = "";
      }
    };

    // IMPORTANTE: Al cambiar de proveedor, limpia todo
    const onProveedorSelect = (event) => {
      const proveedor = event.value;
      predioFscs.value = proveedor.fscs || [];

      // Reset de selección FSC
      fscSeleccionado.value = null;
      form.fscs = [];
      form.fsc_codigo = "";
    };
    const v$ = useVuelidate(rules, form);

    const vVisita$ = useVuelidate(rulesVisita, formVisita);

    //FSC para predios:
    onMounted(getCRUD);

    return {
      dt,
      loading,
      saving,
      ppredio,
      ppredios,
      proveedores,
      origenes,
      filters,
      bitacora,
      bitacoraPprediosDialog,
      bitacoraPpredio,
      visitasPprediosDialog,
      visitasPpredio,
      visitas,
      openNewVisita,
      ppredioVisitaDialog,
      deletePpredioDialog,
      setPredios,
      ppredioDialog,
      submitted,
      filteredProveedores,
      filteredOrigenes,
      filteredPredios,
      v$,
      vVisita$,
      form,
      formVisita,
      messages,
      hideDialog,
      hideDialogVisita,
      openNew,
      confirmDeletePpredio,
      deletePpredio,
      exportCSV,
      confirmDeleteSelected,
      searchComuna,
      searchProveedor,
      searchPredio,
      editPpredio,
      savePpredio,
      saveVisita,
      storePpredio,
      storeVisita,
      formatCurrency,
      formatFecha,
      toggleDelete,
      setVolumenes,
      deleteVisitaDialog,
      deleteVisita,
      confirmDeletePpredioVisita,
      pprediosExport,
      onFscChange,
      onProveedorSelect,
      predioFscs,
      fscSeleccionado,
      fsc_codigo_temporal,
    };
  },
};
</script>